import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { GENRES } from "../lib/genres";

// Horizontal, mobile-friendly "Browse by Genre" chip row for the homepages.
// Caller supplies any horizontal padding via `className` (homes differ).
export default function GenreChipRow({ className = "", wrap = false }) {
  const navigate = useNavigate();
  return (
    <section className={className} data-testid="home-genre-row">
      <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[var(--text-muted)]">Browse by Genre</p>
      <div className={`flex gap-2 pb-1 ${wrap ? "scrollbar-none overflow-x-auto md:flex-wrap md:overflow-visible" : "scrollbar-none overflow-x-auto"}`}>
        <button
          onClick={() => navigate("/friends-favorites")}
          data-testid="home-genre-friends-favorites"
          className="genre-pill genre-pill-active inline-flex flex-none items-center gap-1.5"
        >
          <Heart size={13} fill="currentColor" /> Friends' Favorites
        </button>
        {GENRES.map((g) => (
          <button
            key={g.slug}
            onClick={() => navigate(`/genre/${g.slug}`)}
            data-testid={`home-genre-${g.slug}`}
            className="genre-pill flex-none"
          >
            {g.name}
          </button>
        ))}
      </div>
    </section>
  );
}
